"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventNames = void 0;
exports.eventNames = {
    service_worker_not_supported_by_browser: 'service_worker_not_supported_by_browser',
    token_aquired: 'token_aquired',
    logout_from_another_tab: 'logout_from_another_tab',
    logout_from_same_tab: 'logout_from_same_tab',
    token_renewed: 'token_renewed',
    token_timer: 'token_timer',
    loginAsync_begin: 'loginAsync_begin',
    loginAsync_error: 'loginAsync_error',
    loginCallbackAsync_begin: 'loginCallbackAsync_begin',
    loginCallbackAsync_end: 'loginCallbackAsync_end',
    loginCallbackAsync_error: 'loginCallbackAsync_error',
    refreshTokensAsync_begin: 'refreshTokensAsync_begin',
    refreshTokensAsync: 'refreshTokensAsync',
    refreshTokensAsync_end: 'refreshTokensAsync_end',
    refreshTokensAsync_error: 'refreshTokensAsync_error',
    refreshTokensAsync_silent_error: 'refreshTokensAsync_silent_error',
    tryKeepExistingSessionAsync_begin: 'tryKeepExistingSessionAsync_begin',
    tryKeepExistingSessionAsync_end: 'tryKeepExistingSessionAsync_end',
    tryKeepExistingSessionAsync_error: 'tryKeepExistingSessionAsync_error',
    silentLoginAsync_begin: 'silentLoginAsync_begin',
    silentLoginAsync: 'silentLoginAsync',
    silentLoginAsync_end: 'silentLoginAsync_end',
    silentLoginAsync_error: 'silentLoginAsync_error',
    syncTokensAsync_begin: 'syncTokensAsync_begin',
    syncTokensAsync_end: 'syncTokensAsync_end',
    syncTokensAsync_error: 'syncTokensAsync_error',
};
//# sourceMappingURL=events.js.map